import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  getCommAuditTrails,
  searchCasesApi,
  createCommAuditTrail,
} from "../../../api/commAuditTrails_api";

export const getCommAuditTrailsAction = createAsyncThunk(
  "commAuditTrails/getCommAuditTrails",
  async (data, { rejectWithValue }) => {
    try {
      const response = await getCommAuditTrails(data);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  },
);

export const searchCasesAction = createAsyncThunk(
  "commAuditTrails/searchCasesApi",
  async (data, { rejectWithValue }) => {
    try {
      const response = await searchCasesApi(data);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  },
);

export const createCommAuditTrailAction = createAsyncThunk(
  "commAuditTrails/createCommAuditTrail",
  async (data, { rejectWithValue }) => {
    try {
      const response = await createCommAuditTrail(data);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  },
);
